import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons';

const TrashIcon = ({ className = '', ...rest }) => {
  return <FontAwesomeIcon icon={faTrashAlt} {...rest} className={className} />;
};

export default TrashIcon;
